/* ============================================================
   Eldiven Pazari - Mobil menu alt kategori ac/kapa
   Sadece #Drawer-Menu icinde, alt kategorilerin ust kategoriyle
   AYNI listede (kardes) oldugu duz dalda calisir.
   Shopify menuler en fazla 3 seviye destekledigi icin o dalda
   gercek ic ice yapi kurulamiyor; burada gorsel olarak gruplaniyor.
   ============================================================ */
(function () {
  'use strict';

  var GROUPS = [
    {
      parent: '/collections/nitril-eldiven',
      children: [
        '/collections/mavi-nitril-eldiven',
        '/collections/siyah-nitril-eldiven',
        '/collections/pembe-nitril-eldiven',
        '/collections/pudrasiz-nitril-eldiven'
      ]
    },
    {
      parent: '/collections/lateks-eldiven',
      children: [
        '/collections/pudrali-lateks-eldiven',
        '/collections/pudrasiz-lateks-eldiven'
      ]
    }
  ];

  function setupGroup(drawer, group) {
    var parentLinks = drawer.querySelectorAll('a[href="' + group.parent + '"]');

    Array.prototype.forEach.call(parentLinks, function (parentLink) {
      // "... 'a git" linkleri temanin kendi drill-down panelinin basligidir,
      // orada alt kategoriler zaten dogru calisiyor; dokunma.
      if (parentLink.classList.contains('link--go-to')) return;

      var parentLi = parentLink.closest('li');
      if (!parentLi || parentLi.hasAttribute('data-ep-msub')) return;

      var list = parentLi.parentElement;
      if (!list) return;

      // Alt kategoriler ayni listede kardes mi? Degilse bu dal degil, dokunma.
      var childLis = [];
      group.children.forEach(function (href) {
        var childLink = list.querySelector(':scope > li > a[href="' + href + '"]');
        if (childLink) {
          var li = childLink.closest('li');
          if (li && li.parentElement === list) childLis.push(li);
        }
      });
      if (childLis.length === 0) return;

      parentLi.setAttribute('data-ep-msub', 'parent');
      parentLi.classList.add('ep-msub-parent');

      childLis.forEach(function (li) {
        li.classList.add('ep-msub-child');
        li.hidden = true;
      });

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'ep-msub-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Alt kategorileri goster');

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        childLis.forEach(function (li) { li.hidden = open; });
      });

      parentLi.appendChild(toggle);
    });
  }

  function init() {
    var drawer = document.getElementById('Drawer-Menu');
    if (!drawer) return;
    GROUPS.forEach(function (g) { setupGroup(drawer, g); });
  }

  function boot() {
    init();
    var drawer = document.getElementById('Drawer-Menu');
    if (!drawer || !window.MutationObserver) return;
    // Tema menuyu yeniden render ederse tekrar kur
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.setTimeout(function () { pending = false; init(); }, 120);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ============================================================
   Eldiven Pazari - Secim senkronizasyonu
   Kademe kartlari (coklu-alim) ile temanin varyant secicisi
   ayni secenegi (Kutu / Beden) gostersin. Birinde secilince
   digeri de otomatik ayni degere gecer.

   Eslesme secenek DEGERINE gore yapilir (orn "5 Kutu", "M").
   Eldiven urunlerinde Beden ve Kutu degerleri farkli oldugu
   icin deger bazli eslesme guvenlidir.
   ============================================================ */
(function () {
  'use strict';

  // Sadece kademe karti formu olan sayfalarda calis (urun sayfasi)
  if (!document.querySelector('.ep-bundle__form')) return;

  var syncing = false;

  function norm(s) { return (s || '').trim(); }

  // Tema varyant radiolari: data-option-value-id tasir
  function themeRadios() {
    return document.querySelectorAll('input[type="radio"][data-option-value-id]');
  }
  // Kademe karti radiolari: .ep-bundle__form icinde, data-option-position tasir
  function bundleRadios() {
    return document.querySelectorAll('.ep-bundle__form input[type="radio"][data-option-position]');
  }

  function setByValue(radios, value) {
    var changed = [];
    radios.forEach(function (r) {
      if (norm(r.value) === value && !r.checked && !r.disabled) {
        r.checked = true;
        changed.push(r);
      }
    });
    return changed;
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.type !== 'radio' || syncing) return;

    var isTheme = el.hasAttribute('data-option-value-id');
    var isBundle = el.hasAttribute('data-option-position') && el.closest('.ep-bundle__form');
    if (!isTheme && !isBundle) return;

    var value = norm(el.value);
    syncing = true;
    try {
      var changed;
      if (isBundle) {
        changed = setByValue(themeRadios(), value);
      } else {
        changed = setByValue(bundleRadios(), value);
      }
      // Karsi taraftaki radionun kendi JS'i tetiklensin (fiyat/kart/varyant guncellensin)
      changed.forEach(function (r) {
        r.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } finally {
      syncing = false;
    }
  }, true);
})();


/* ============================================================
   Koleksiyon KATEGORILER menusu - + ikonuna tiklayinca ac/kapa.
   Aktif dal CSS ile zaten acik; bu, diger dallari elle acmak icin.
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.blog-post__category-list .icon-dropdown');
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation();
    var li = toggle.closest('li');
    if (li) li.classList.toggle('ep-cat-open');
  });
})();


/* ============================================================
   MEGA MENU: alt kategorileri SAGA ACILAN panele tasi (flyout)
   ------------------------------------------------------------
   Sorun: "Nitril Eldiven" acilinca varyantlari (Mavi/Siyah/Pembe/
   Pudrasiz) listeye eklendigi icin liste uzuyordu. Fare asagi
   "Lateks Eldiven"e inerken grup kapaniyor, liste kisaliyor ve
   Lateks yukari sicrayip imlecin altindan kaciyordu.

   Cozum: varyantlar akistan cikarilip ust ogenin icinde konumlanan
   bir panele tasiniyor. Ana listenin boyu artik hic degismiyor,
   dolayisiyla Lateks yerinden oynamiyor.

   Guvenlik: gruplar KONUMA gore degil, ust ogenin HREF'ine gore
   bulunuyor. Menu degisir de beklenen baglanti bulunmazsa hicbir
   sey yapilmaz; sayfa eski (CSS akordeon) davranisiyla calisir.
   ============================================================ */
(function () {
  'use strict';

  var GRUPLAR = [
    { ustHref: '/collections/nitril-eldiven', altAdet: 4 },
    { ustHref: '/collections/lateks-eldiven', altAdet: 2 }
  ];

  function yol(a) {
    try { return new URL(a.getAttribute('href'), location.origin).pathname; }
    catch (e) { return ''; }
  }

  function kur(liste) {
    if (liste.dataset.epFlyout) return;

    var kuruldu = 0;

    GRUPLAR.forEach(function (g) {
      var ogeler = Array.prototype.slice.call(liste.children);
      var ust = null;

      for (var i = 0; i < ogeler.length; i++) {
        var a = ogeler[i].querySelector('a');
        if (a && yol(a) === g.ustHref) { ust = ogeler[i]; break; }
      }
      if (!ust) return;                       // beklenen ust oge yok -> dokunma

      var cocuklar = [];
      var s = ust.nextElementSibling;
      while (s && cocuklar.length < g.altAdet) {
        cocuklar.push(s);
        s = s.nextElementSibling;
      }
      if (cocuklar.length !== g.altAdet) return;  // eksik -> dokunma

      var panel = document.createElement('ul');
      panel.className = 'ep-mega-menu__flyout list-unstyled';
      panel.setAttribute('role', 'list');
      cocuklar.forEach(function (c) { panel.appendChild(c); });

      ust.appendChild(panel);
      ust.classList.add('ep-has-flyout');
      kuruldu++;
    });

    if (kuruldu) {
      liste.classList.add('ep-flyout-ready');
      liste.dataset.epFlyout = '1';
    }
  }

  function tara(kok) {
    (kok || document).querySelectorAll(
      '.ep-mega-menu__column:has(> a.ep-mega-menu__category[href*="/collections/tek-kullanimlik-eldivenler"]) .ep-mega-menu__sublist'
    ).forEach(kur);
  }

  function baslat() {
    try { tara(document); } catch (e) { /* :has desteklenmiyorsa sessizce gec */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  // Mega menu icerigi tembel (lazy) basiliyor; sonradan gelirse de yakala.
  var gozlemci = new MutationObserver(function () { baslat(); });
  gozlemci.observe(document.documentElement, { childList: true, subtree: true });
})();
